"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InhouseSopInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _CustomInput = require("../CustomInput");
var _Button = require("../Button");
var _RichText = require("../RichText");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var InhouseSopInput = function InhouseSopInput(props) {
  var _ref = props || {},
    title = _ref.title,
    _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps,
    _ref$inputProps = _ref.inputProps,
    inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inputDisabled = _useState2[0],
    setInputDisabled = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  var _useState5 = (0, _react.useState)(buttonProps),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    buttonPropsCache = _useState6[0],
    setButtonPropsCache = _useState6[1];
  var handleButtonClick = function handleButtonClick() {
    setInputDisabled(!inputDisabled);
  };
  var handleInputChange = function handleInputChange(v) {
    var _buttonPropsCache$act;
    if (buttonPropsCache !== null && buttonPropsCache !== void 0 && (_buttonPropsCache$act = buttonPropsCache.action) !== null && _buttonPropsCache$act !== void 0 && _buttonPropsCache$act.button_text) {
      var newProps = _objectSpread(_objectSpread({}, buttonPropsCache), {}, {
        action: _objectSpread(_objectSpread({}, buttonPropsCache.action), {}, {
          button_text: v
        }),
        realText: v
      });
      setButtonPropsCache(newProps);
    }
    setInputValue(v);
  };
  var showButton = (0, _react.useMemo)(function () {
    if (!inputValue) {
      return true;
    }
    return !inputDisabled;
  }, [inputDisabled, inputValue]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '300px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: '12px'
    }
  }, /*#__PURE__*/_react.default.createElement(_RichText.RichText, {
    content: title || ''
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: '12px'
    }
  }, /*#__PURE__*/_react.default.createElement(_CustomInput.Input, (0, _extends2.default)({}, inputProps, {
    value: inputValue,
    onChange: handleInputChange,
    disabled: inputDisabled
  }))), showButton && /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({
    disabled: !inputValue
  }, buttonPropsCache, {
    onClick: handleButtonClick
  })));
};
exports.InhouseSopInput = InhouseSopInput;